
import { PipeTransform, Pipe } from '@angular/core';
import { AppService } from '../app.service';
import { BuywifiService } from '../services/buywifi.service';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '../util.service';

@Pipe({
    name: 'formatPrice',
    pure: false
})
export class FormatPricePipe implements PipeTransform {

    constructor(private appService: AppService,
        private buywifiService: BuywifiService,
        private utilService: UtilService,
        private translate: TranslateService) { }
    transform(price: number, isRevenue: boolean, isCodeRequired: boolean, points?: string, isPriceOnly?: boolean): string | undefined {
        if (this.utilService.utility !== undefined) {
            return this.utilService.utility.formatting.transform(price, isRevenue, isCodeRequired, points, isPriceOnly);
        } else {
            const currentPos = (this.buywifiService.currencyPos).toUpperCase();
            this.utilService.initiateUtilLib(currentPos);
        }
    }
}
